(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-model/assets/javascripts/models/wager.js') >= 0) return;  svs.modules.push('/components/numbergames/game-model/assets/javascripts/models/wager.js'); 
'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
svs.numbergames.game_model.models.Wager = svs.numbergames.core.NumbergamesModel.extend({
  defaults() {
    return {
      productId: '',
      rowPrice: 0,
      rowPriceMulti: 1,
      boards: undefined,
      numberOfValidBoards: 0,
      jokerRow: [],
      jokerPrice: 0,
      jokerIsValid: true,
      hasJoker: false,
      drawCount: '1',
      selectedDays: [],
      price: 0,
      isValid: false,
      isSyndicate: false,
      syndicateId: 0,
      isPackage: false,
      isSystem: false,
      isSingle: false,
      isSubscription: false,
      subscriptionId: undefined,
      packages: {},
      selectedPackage: 0,
      prolongedBet: undefined
    };
  },
  initialize(attrs) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    svs.numbergames.game_model.logger.debug('models.Wager initialize', this.attributes);
    this.storageKey = options.storageKey;
    this.setNumberOfValidBoards();
    this.calculatePrice();
    this.setValid();
    this.listenTo(this, 'change:drawCount', this.drawCountChanged);
    this.listenTo(this, 'change:jokerPrice', this.jokerPriceChanged);
    this.listenTo(this, 'change:syndicateId', this.saveToLocalStorage);
    this.listenTo(this, 'change:syndicateId', this.setIsSyndicate);
    this.listenTo(this, "change:rowPrice\n      change:jokerPrice\n      change:drawCount\n      change:selectedDays\n      change:rowPriceMulti\n      change:numberOfValidBoards", this.calculatePrice);
    this.listenTo(this.get('boards'), 'change:price', this.calculatePrice);
    this.listenTo(this.get('boards'), 'change:rowCount', this.setNumberOfValidBoards);
    this.listenTo(this, 'change:jokerRow', this.saveToLocalStorage);
    this.listenTo(this.get('boards'), 'change:board', this.saveToLocalStorage);
    this.listenTo(this, 'change:price change:jokerIsValid', this.setValid);
  },
  parse(attrs) {
    var _attrs$boards;
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    svs.numbergames.game_model.logger.debug('models.Wager parse', attrs);
    attrs.productId = svs.numbergames.productMapping.getProductId(attrs.productId);
    const rules = options.rules || svs.numbergames.rules[attrs.productId];
    svs.numbergames.game_model.rulesRadio.trigger('setRules', rules);
    const collectionOptions = {
      productId: attrs.productId,
      isPackage: attrs.isPackage,
      isSystem: attrs.isSystem,
      noEmptyBoards: options.noEmptyBoards,
      rules,
      parse: true
    };
    const gameParams = svs.numbergames.game_model.utils.paramParser();
    if (options.storageKey && !Object.entries(gameParams).length) {
      const loadedAttrs = svs.components.Storage.browser.get(options.storageKey, attrs.productId);
      if (loadedAttrs) attrs = loadedAttrs;
    } else if (gameParams.preHuxfluxed) {
      collectionOptions.preHuxfluxed = gameParams.preHuxfluxed;
    }
    if (attrs.jokerPrice) attrs.hasJoker = true;
    if (rules.rowPrice) attrs.rowPrice = rules.rowPrice;
    const isLotto = svs.numbergames.productMapping.isLotto(attrs.productId);
    if (!attrs.isPackage && ((_attrs$boards = attrs.boards) === null || _attrs$boards === void 0 ? void 0 : _attrs$boards.length) > rules.maxNumberOfRows) {
      svs.numbergames.game_model.logger.warn("Got ".concat(attrs.boards.length, " boards but max allowed is ").concat(rules.maxNumberOfRows, ". This should not happen in PROD!"));
      attrs.boards = attrs.boards.splice(0, rules.maxNumberOfRows);
    }

    if (isLotto && attrs.isPackage && gameParams.rowPriceMulti) delete gameParams.rowPriceMulti;
    attrs = _objectSpread(_objectSpread({}, attrs), gameParams);
    if (attrs.drawCount) {
      attrs.isSubscription = attrs.drawCount === 'subscription';
    } else if (attrs.isSubscription) {
      attrs.drawCount = 'subscription';
    }
    attrs.boards = new svs.numbergames.game_model.collections.Boards(attrs.boards, collectionOptions);
    this.bagTypeIdMap = options.bagTypeIdMap;
    attrs.isSyndicate = Boolean(attrs.syndicateId);
    if (svs.numbergames.productMapping.hasJoker(attrs.productId)) {
      if (attrs.jokerRow) {
        attrs.jokerRow = attrs.jokerRow.map(num => typeof num !== 'object' ? {
          number: num,
          manual: false
        } : num);
      } else {
        attrs.jokerRow = svs.numbergames.rules.joker.getHuxfluxedRow();
      }
    }

    if (svs.numbergames.productMapping.isEurojackpot(attrs.productId) && (!Array.isArray(attrs.selectedDays) || !attrs.selectedDays.length)) {
      attrs.selectedDays = ['ELOTTO'];
    }
    return attrs;
  },
  drawCountChanged(model, drawCount) {
    this.set({
      isSubscription: drawCount === 'subscription'
    });
  },
  getJokerRowAsArray() {
    return this.get('jokerRow').map(numObj => numObj.number);
  },
  getJokerRowAsString() {
    return this.getJokerRowAsArray().join('');
  },
  jokerPriceChanged(model, jokerPrice) {
    if (typeof jokerPrice === 'undefined') this.set({
      jokerPrice: 0
    }, {
      silent: true
    });
    this.set({
      hasJoker: Boolean(jokerPrice)
    });
  },
  calculatePrice() {
    let price = 0;
    price += this.get('boards').calculatePrice();
    price *= this.get('rowPriceMulti');
    if (price) price += this.get('jokerPrice');
    price *= parseInt(this.get('drawCount'), 10) || 1;
    if (svs.numbergames.productMapping.isProductFamily(this.get('productId'))) price *= this.get('selectedDays').length;
    this.set({
      price
    });
    this.saveToLocalStorage();
  },
  setNumberOfValidBoards() {
    this.set({
      numberOfValidBoards: this.get('boards').getNumberOfValidBoards()
    });
  },
  setValid() {
    this.set({
      isValid: this.checkValid()
    });
  },
  checkValid() {
    if (!this.get('price')) {
      return false;
    }
    const numberOfValidBoards = this.get('boards').getNumberOfValidBoards();
    const isLotto = svs.numbergames.productMapping.isLotto(this.get('productId'));
    if (numberOfValidBoards < 1) {
      return false;
    }
    if (isLotto) {
      if (!this.get('selectedDays').length || !svs.core.detect.feature('ft-lotto-selfservice-min-boards') && svs.numbergames.game_model.utils.isSelfService() && numberOfValidBoards < 2) {
        return false;
      }
    }
    if (this.get('hasJoker') && !this.get('jokerIsValid')) return false;
    return true;
  },
  setIsSyndicate() {
    this.set('isSyndicate', Boolean(this.get('syndicateId')));
  },
  setPackage(size) {
    size = parseInt(size, 10);
    const currentPackage = this.get('selectedPackage');
    const packages = this.get('packages');
    const rules = svs.numbergames.game_model.rulesRadio.request('rules');
    const packageRules = rules.PACKAGES[size];
    if (!packageRules || size === currentPackage) return;
    if (currentPackage) packages[currentPackage] = this.get('boards').models.map(m => m.attributes);
    if (!packages[size]) packages[size] = this.get('boards').generatePackageBoards(size);
    this.get('boards').reset(packages[size], {
      isPackage: true
    });
    this.set({
      selectedPackage: size,
      jokerPrice: packageRules.jokerPrice
    });
    this.setNumberOfValidBoards();
  },
  toAPIJSON() {
    switch (this.get('selectedDays').length) {
      case 1:
        return new svs.numbergames.game_model.utils.API_Wager({
          wagerModel: this,
          day: this.get('selectedDays')[0]
        });
      case 2:
        {
          const wagerArray = [];
          this.get('selectedDays').forEach(day => {
            wagerArray.push(new svs.numbergames.game_model.utils.API_Wager({
              wagerModel: this,
              day
            }));
          });
          return wagerArray;
        }
      default:
        return new svs.numbergames.game_model.utils.API_Wager({
          wagerModel: this
        });
    }
  },
  saveToLocalStorage() {
    if (this.storageKey) svs.components.Storage.browser.set(this.storageKey, this.get('productId'), this.attributes, svs.components.Storage.constants.EXPIRES_1H);
  },
  removeFromLocalStorage(callback) {
    if (this.storageKey) svs.components.Storage.browser.remove(this.storageKey, this.get('productId'), callback);
  },
  toObject() {
    const attrs = _objectSpread({}, this.attributes),
      validBoards = this.get('boards').getValidBoards();
    attrs.boards = validBoards.map(board => _objectSpread({}, board.attributes));
    return attrs;
  },
  getSubscriptionPackageId() {
    const returnObj = {};
    if (this.get('selectedPackage') && this.bagTypeIdMap) {
      if (svs.numbergames.productMapping.isProductFamily(this.get('productId'))) {
        this.get('selectedDays').forEach((day, i) => {
          const dayString = svs.numbergames.productMapping.getDay(day);
          const packageString = "".concat(this.get('selectedPackage'), " ").concat(dayString);
          returnObj["packageIdWager".concat(i)] = this.bagTypeIdMap[packageString];
        });
      } else {
        returnObj.packageIdWager0 = this.bagTypeIdMap[this.get('selectedPackage')];
      }
    }
    return returnObj;
  },
  getQuickpickState() {

    const validBoards = this.get('boards').getValidBoards();
    let quickPickState = 0;
    validBoards.forEach(board => {
      let totalLength = board.get('numbers').length;
      let manualLength = board.get('numbers').getManualNumbersLength();
      if (board.has('numbersExtra')) {
        totalLength += board.get('numbersExtra').length;
        manualLength += board.get('numbersExtra').getManualNumbersLength();
      }
      if (manualLength === 0 && quickPickState !== 4) {
        quickPickState = 1;
      } else if (manualLength < totalLength) {
        quickPickState = 4;
      }
    });
    return quickPickState;
  }
});
 })(window);